import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-smash-manufacture',
  templateUrl: './smash-manufacture.component.html',
  styleUrls: ['./smash-manufacture.component.scss']
})
export class SmashManufactureComponent implements OnInit {

  @Input() selectedLanguage: string;
  @Input() shadowEnabled = false;
  @Input() color: string;

  constructor() { }

  ngOnInit() {
  }

}
